import React from 'react';
import AssignAdvisorControl from '../../sales_task_list/advisors/AssignAdvisorControl';
import type { Notify } from '../../sales_task_list/advisors/AssignAdvisorModal';
import salesAdvisorLabel, { hasNoAdvisor } from './sales_advisor_label';

interface Props {
  // null = nobody assigned, undefined = older server (shows nothing).
  advisor: { name?: string; source?: string; expires_at?: string } | null | undefined;
  studentUuid: string;
  studentName: string;
  isSuperUser: boolean;
  // Banned / deleted students cannot be assigned (server answers 400 STUDENT_INELIGIBLE).
  ineligible?: boolean;
  notify: Notify;
  // Reload the profile after an assign / 409 so the new advisor shows.
  onReload: () => void;
}

// Profile slot: Assign button when nobody holds the student, else the advisor label.
function SalesAdvisorSlot({
  advisor,
  studentUuid,
  studentName,
  isSuperUser,
  ineligible,
  notify,
  onReload
}: Props) {
  if (hasNoAdvisor(advisor)) {
    if (ineligible) return null;
    return (
      <div className="flex justify-center item-center" data-testid="sales-advisor-assign">
        <AssignAdvisorControl
          studentUuid={studentUuid}
          studentName={studentName}
          isSuperUser={isSuperUser}
          notify={notify}
          onDone={onReload}
        />
      </div>
    );
  }
  const label = salesAdvisorLabel(advisor);
  if (!label) return null;
  return (
    <div className="flex justify-center item-center" data-testid="sales-advisor-label">
      <div className="text-center">
        <div>{label.text}</div>
        {label.detail ? <div className="text-xs">{label.detail}</div> : null}
      </div>
    </div>
  );
}

export default SalesAdvisorSlot;
